import { t } from "./kieli";

/**
 * Linkit.tsx — tunniste on linkki siellä missä riviltä lähdetään eteenpäin.
 *
 * Toni 8.9.2026, Luovutusvalmiuden korjattavien listalta: LINJA- ja
 * KOHDE-sarake olivat pelkkää tekstiä, ja lista on työjono eikä raportti —
 * sen ainoa käyttötapa on valita rivi ja mennä sille linjalle. Juuri
 * siinä ketju katkesi ja linja haettiin käsin Selailusta. Mitattu ennen
 * korjausta: tekstinä kolmessa näkymässä (Luovutusvalmius 2 taulukkoa,
 * Hubin viimeisimmät kirjaukset, Selailun «Kaikki linjat»), Punch-lista
 * oli jo linkki (4.9.). Kuusi solua on yksi komponentti, ei kuusi
 * korjausta.
 *
 * Linkki vie OSOITTEESEEN (#/selailu/<tunnus>, #/hub/<tunnus>): F5 ja
 * lähetetty linkki palauttavat saman rivin, sama mekanismi kuin Hubin
 * luvuilla (osoitehaku.ts). Kävely (deploy/kavely.mjs) lukee
 * `a[data-tunniste]`-linkit ja vaatii että ensimmäinen vie riville joka
 * on olemassa: kohdenäkymässä on `[data-linja]` / `[data-kohde]` samalla
 * arvolla. Ilman sitä ehtoa korjaus rapistuu kuten muutkin
 * näkymäkorjaukset.
 */

/* 10.10.2026 Toni (tilaajan näkymä): linkki ei saa viedä näkymään joka on tunnukselta suljettu — tilaajalla esim. «150
   linjaa» → Selailu. main.tsx asettaa avattavat näkymät (tilaajalle sallittujen lista); muille kaikki avautuu. Linkki
   suljettuun näkymään piirtyy tekstinä: arvo näkyy, siirtymää ei luvata. */
let avattavat: readonly string[] | null = null;
export function asetaAvattavat(lista: readonly string[] | null): void { avattavat = lista; }
export function saaAvata(osoite: string): boolean {
  if (!avattavat) return true;
  return avattavat.includes(osoite.replace(/^#\//, "").split(/[/?]/)[0] ?? "");
}

/** T469 (10.10.2026): hitsiä koskeva rivi (puute) vie hitsin riville, ei vain linjalle. */
export function HitsiLinkki({ linja, hitsiId, teksti, title }: { linja: string | null | undefined; hitsiId: number; teksti: string; title?: string }) {
  if (!linja) return <span className="dim">—</span>;
  if (!saaAvata("#/selailu")) return <span data-tunniste-suljettu="hitsi">{teksti}</span>;
  return (
    <a className="hub__linkki" data-tunniste="hitsi" data-tunnus={linja} data-hitsi-id={hitsiId}
       href={"#/selailu/" + encodeURIComponent(linja) + "?hitsi=" + hitsiId} title={title ?? t("muu.linkit.hitsi")}>{teksti}</a>
  );
}

export function LinjaLinkki({ tunnus, title }: { tunnus: string | null | undefined; title?: string }) {
  if (!tunnus) return <span className="dim">—</span>;
  if (!saaAvata("#/selailu")) return <span data-tunniste-suljettu="linja">{tunnus}</span>;
  return (
    <a className="hub__linkki" data-tunniste="linja" data-tunnus={tunnus}
       href={"#/selailu/" + encodeURIComponent(tunnus)} title={title ?? t("muu.linkit.linja")}>{tunnus}</a>
  );
}

export function KohdeLinkki({ tunnus, title }: { tunnus: string | null | undefined; title?: string }) {
  if (!tunnus) return <span className="dim">—</span>;
  return (
    <a className="hub__linkki" data-tunniste="kohde" data-tunnus={tunnus}
       href={"#/hub/" + encodeURIComponent(tunnus)} title={title ?? t("muu.linkit.kohde")}>{tunnus}</a>
  );
}
